module.exports = __webpack_public_path__ + "static/media/Omak Logo.bf34ab60.png";